import React, { useRef } from "react";
import Draggable from 'react-draggable';
import { Button, Modal } from "semantic-ui-react";
import { mockResponseNL } from "../../components/NL_App/api/mockAPIEventsNL";
import './entryStatusModalStyle.scss';
import MockFieldsNL from "./mockComponents/MockFieldsNL";

const NLUpdateResponseEntry = ({shipmentId, buttonTitle, ESCustomState, propMRN, propDUCR, serviceType, transmissionType}) => {
    const [open, setOpen] = React.useState(false);
    const reference = useRef(null);
    const [mandErr, setMandErr] = React.useState(false)

    const submitHandler = () => {
        const data = reference.current?.getUpdateResponseData()
        const {mrn, shipmentId, statusCode} = data.common
        setMandErr(false)
        if(mrn === "" || shipmentId === "" | statusCode === -1)
        {
            setMandErr(true)
            return;
        }
        mockResponseNL(mrn, shipmentId, statusCode).then((response) => {
            document.getElementById(`card-${shipmentId}`).click();
            //console.log(response)
        })
        .catch((err) => console.log(err))
        setOpen(false)
    }
    return (
        <Draggable
        handle=".header"
    >
        <Modal
            size="small"
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={<Button
                size="mini"
                key="UPDATE_RESPONSE"
                disabled={false}
                className="sv todo-button primaryBtn"
                onClick={(e) => {
                    setMandErr(false)
                    e.stopPropagation();
                }}
            >
                {buttonTitle}
            </Button>}
        >
            <Modal.Header className="entry-modal-header">Update Response: {shipmentId}</Modal.Header>
            <Modal.Content className="entry-status-modal-content">
                {mandErr && <div className="mand-error-div">
                    <h5>* All Fields are Mandatory</h5>
                </div>}
                <MockFieldsNL reference={reference} propMRN={propMRN} propShipmentId={shipmentId} ESCustomState={ESCustomState} transmissionType={transmissionType} />
            </Modal.Content>
            <Modal.Actions>
                <Button color="blue" onClick={() => {setOpen(false)}}>
                    Cancel
                </Button>
                <Button positive onClick={() => submitHandler()}>
                  Submit
                </Button>
            </Modal.Actions>
            
        </Modal>
    </Draggable>
    );
}

export default NLUpdateResponseEntry;